var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.141,
    height: 1354.457,
    viewBox: "0 0 220.141 1354.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1405.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1405.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M128.9,0l24.763,36.874L178.431,0Z",
    transform: "translate(-43.595)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M120.835,30.829l19.7,29.332,19.7-29.332L140.539,1.5Z",
    transform: "translate(-76.166 6.043)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M178.38,30.829,158.675,1.5l-19.7,29.332,19.7,29.332Z",
    transform: "translate(-2.91 6.043)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M153.569,0l-4.5,6.711,6.217,9.27,6.237-9.27L157.01,0Z",
    transform: "translate(37.85)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M157.357,2.485l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(46.172 10.034)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M120.6,0l-4.509,6.711,6.232,9.27,6.222-9.27L124.041,0Z",
    transform: "translate(-95.325)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M114.03,11.756l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-103.645 10.036)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M164.353,20.5,147.747,45.219l16.606,24.722,16.606-24.722Z",
    transform: "translate(32.509 82.767)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M159.505,27.438,142.894,52.16l16.611,24.722L176.111,52.16Z",
    transform: "translate(12.914 110.8)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M129.9,69.941,146.5,45.218,129.9,20.5,113.293,45.218Z",
    transform: "translate(-106.622 82.767)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M134.751,76.883,151.357,52.16,134.751,27.438,118.145,52.16Z",
    transform: "translate(-87.029 110.8)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M126.837,59.656l15.926,23.71,19.231-28.632L181.23,83.365l15.931-23.71L161.994,7.319Z",
    transform: "translate(-51.927 29.556)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M132.58,33.686l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-28.737 98.596)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M145.034,44.682l-6.222-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-28.738 143)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M130.519,41.689l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-37.062 130.913)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M128.458,38.7l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-45.383 118.824)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M126.4,35.7l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-53.708 106.737)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M136.79,32.709l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-62.03 94.65)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M122.274,29.715l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-70.353 82.561)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M132.668,26.722l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-78.676 70.475)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M130.607,23.729l-6.227-9.27-6.227,9.27L124.38,33Z",
    transform: "translate(-86.998 58.388)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M116.091,20.735l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-95.322 46.299)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M124.423,14.749,118.2,5.478l-6.227,9.27,6.227,9.27Z",
    transform: "translate(-111.969 22.123)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M120.257,27.012l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-103.645 34.211)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M134.641,41.689l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-20.416 130.913)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M136.7,38.7l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-12.092 118.824)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M151.218,35.7l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-3.768 106.737)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M147.052,23.438l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(4.555 94.649)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M155.34,29.715l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(12.878 82.561)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M144.946,26.722l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(21.2 70.475)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M159.462,23.729l-6.227-9.27-6.227,9.27L153.235,33Z",
    transform: "translate(29.523 58.388)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M161.527,20.735l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(37.844 46.299)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M159.418,24.019l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(54.493 22.124)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M163.584,17.742l-6.222-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(46.169 34.212)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M155.015,58.12h.005L139.074,34.38,123.128,58.12h0l15.946,23.74L155.02,58.12Z",
    transform: "translate(-66.906 138.832)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M129.9,97.319,146.5,72.6,129.9,47.874,113.293,72.6Z",
    transform: "translate(-106.622 193.324)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M134.751,90.377l16.606-24.722L134.751,40.932,118.145,65.655Z",
    transform: "translate(-87.029 165.292)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M170.066,58.12,154.12,34.38,138.174,58.12h0L154.12,81.86Z",
    transform: "translate(-6.148 138.834)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M164.353,47.874,147.747,72.6l16.606,24.722L180.959,72.6Z",
    transform: "translate(32.509 193.324)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M159.505,40.932,142.894,65.655l16.611,24.722,16.606-24.722Z",
    transform: "translate(12.914 165.292)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M181.225,55.771,162,84.4,142.758,55.771l-15.921,23.71L162,131.817l35.151-52.337Z",
    transform: "translate(-51.926 225.214)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M132.58,59.359l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-28.737 202.266)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M178.38,94.376l-19.7-29.332-19.7,29.332,19.7,29.332Z",
    transform: "translate(-2.91 262.659)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M138.8,57.633l6.227-9.27-6.227-9.27-6.222,9.27Z",
    transform: "translate(-28.736 157.863)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M147.1,51.356l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-20.418 169.948)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M136.7,54.349l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-12.092 182.037)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M144.986,48.072l-6.222,9.27,6.222,9.27,6.227-9.27Z",
    transform: "translate(-3.765 194.125)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M140.824,60.336l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(4.554 206.213)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M149.108,54.059l-6.222,9.27,6.222,9.27,6.227-9.27Z",
    transform: "translate(12.88 218.3)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M144.946,66.322l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(21.2 230.387)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M147.008,69.316l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(29.524 242.476)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M155.3,63.039l-6.227,9.27,6.227,9.27,6.227-9.27Z",
    transform: "translate(37.847 254.563)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M153.19,78.3l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(54.491 278.739)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M157.357,66.032,151.13,75.3l6.227,9.27,6.222-9.27Z",
    transform: "translate(46.172 266.65)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M130.519,51.356l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-37.062 169.948)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M128.458,54.349l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-45.383 182.037)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M126.4,57.342l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-53.708 194.124)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M130.562,69.606l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-62.031 206.213)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M122.274,63.329,128.5,72.6l6.227-9.27-6.227-9.27Z",
    transform: "translate(-70.353 218.3)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M132.668,66.322l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-78.676 230.387)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M118.152,69.316l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-86.999 242.476)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M116.091,72.309l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-95.322 254.563)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M126.484,75.3l-6.227-9.27L114.03,75.3l6.227,9.27Z",
    transform: "translate(-103.646 266.65)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M164.353,84.043l-16.606,24.722,16.606,24.722,16.606-24.722Z",
    transform: "translate(32.509 339.383)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M159.505,90.985l-16.611,24.722,16.611,24.722,16.606-24.722Z",
    transform: "translate(12.914 367.414)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M129.9,133.484,146.5,108.766,129.9,84.044l-16.606,24.722Z",
    transform: "translate(-106.622 339.385)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M134.751,140.43l16.606-24.722L134.751,90.985l-16.606,24.722Z",
    transform: "translate(-87.029 367.416)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M126.837,123.207l15.926,23.71,19.231-28.637,19.236,28.637,15.931-23.71L161.994,70.865Z",
    transform: "translate(-51.927 286.168)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M145.034,97.234l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-28.738 355.212)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M140.534,123.713l19.7-29.332-19.7-29.337-19.7,29.337Z",
    transform: "translate(-76.166 262.656)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M138.808,98.959l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(-28.736 399.616)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M142.978,105.236l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-37.064 387.529)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M140.912,102.242l-6.227-9.27-6.227,9.27,6.227,9.275Z",
    transform: "translate(-45.384 375.438)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M126.4,99.249l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-53.708 363.351)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M136.79,96.256l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-62.03 351.264)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M128.5,102.533l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-70.352 339.177)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M132.668,90.27,126.441,81l-6.227,9.27,6.227,9.27Z",
    transform: "translate(-78.676 327.09)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M130.607,87.281l-6.227-9.275-6.227,9.275,6.227,9.27Z",
    transform: "translate(-86.998 315)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M122.318,93.557l6.227-9.275-6.227-9.27-6.227,9.27Z",
    transform: "translate(-95.323 302.912)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M124.423,78.3l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-111.969 278.739)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M120.257,90.559l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-103.645 290.825)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M147.1,105.236l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-20.418 387.529)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M149.156,102.242l-6.222-9.27-6.232,9.27,6.232,9.275Z",
    transform: "translate(-12.093 375.438)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M151.218,99.249l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-3.768 363.351)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M147.052,86.986l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(4.555 351.265)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M155.34,93.263l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(12.878 339.177)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M144.946,90.27l6.227,9.27,6.232-9.27L151.173,81Z",
    transform: "translate(21.2 327.09)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M159.462,87.281l-6.227-9.275-6.227,9.275,6.227,9.27Z",
    transform: "translate(29.523 315)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M161.527,84.282l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(37.844 302.912)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M151.13,81.289l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(46.17 290.826)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M155.02,121.667h0l-15.946-23.74-15.946,23.74,15.946,23.74Z",
    transform: "translate(-66.906 395.448)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M129.9,160.862,146.5,136.144,129.9,111.422l-16.606,24.722Z",
    transform: "translate(-106.622 449.942)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M134.751,153.924,151.357,129.2l-16.606-24.722L118.145,129.2Z",
    transform: "translate(-87.029 421.907)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M170.066,121.667h0L154.12,97.927l-15.946,23.74h0l15.946,23.74Z",
    transform: "translate(-6.148 395.448)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M164.353,111.421l-16.606,24.722,16.606,24.717,16.606-24.717Z",
    transform: "translate(32.509 449.94)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M159.505,104.479,142.894,129.2l16.611,24.722L176.111,129.2Z",
    transform: "translate(12.914 421.905)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M197.155,143.028l-15.926-23.71L162,147.955l-19.236-28.637-15.926,23.71L162,195.369Z",
    transform: "translate(-51.929 481.828)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M145.034,122.905l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-28.738 458.88)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M132.58,111.914l6.222,9.27,6.232-9.27-6.232-9.275Z",
    transform: "translate(-28.737 414.475)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M147.1,114.907l-6.227-9.275-6.232,9.275,6.232,9.27Z",
    transform: "translate(-20.418 426.562)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M149.156,117.9l-6.222-9.27L136.7,117.9l6.232,9.27Z",
    transform: "translate(-12.093 438.653)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M151.218,120.89l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-3.768 450.74)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M140.824,123.883l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(4.554 462.827)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M155.34,126.876l-6.227-9.27-6.227,9.27,6.227,9.275Z",
    transform: "translate(12.878 474.914)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M144.946,129.874l6.227,9.27,6.232-9.27-6.232-9.275Z",
    transform: "translate(21.2 487.001)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M147.008,132.863l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(29.524 499.092)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M161.527,135.857l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(37.844 511.178)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M153.19,141.843l6.227,9.275,6.232-9.275-6.232-9.27Z",
    transform: "translate(54.491 535.353)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M157.357,129.58l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(46.172 523.266)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M142.978,114.907l-6.227-9.275-6.232,9.275,6.232,9.27Z",
    transform: "translate(-37.064 426.562)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M140.912,117.9l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-45.384 438.653)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M138.851,120.89l-6.222-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-53.709 450.74)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M136.79,123.883l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-62.03 462.827)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M122.274,126.876l6.227,9.275,6.227-9.275-6.227-9.27Z",
    transform: "translate(-70.353 474.914)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M132.668,129.874l-6.227-9.275-6.227,9.275,6.227,9.27Z",
    transform: "translate(-78.676 487.001)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M130.607,132.863l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-86.998 499.092)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M116.091,135.857l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-95.322 511.178)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M118.2,132.573l-6.227,9.27,6.227,9.275,6.227-9.275Z",
    transform: "translate(-111.968 535.353)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M126.484,138.85l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-103.646 523.266)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M178.38,157.919h0l-19.7-29.327-19.7,29.327,19.7,29.332Z",
    transform: "translate(-2.91 519.277)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M160.239,157.919l-19.7-29.327-19.7,29.327,19.7,29.332Z",
    transform: "translate(-76.165 519.277)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1405.208 677.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8",
    d: "M164.353,20.5,147.747,45.219l16.606,24.722,16.606-24.722Z",
    transform: "translate(32.509 45.892)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M159.505,27.438,142.894,52.16l16.611,24.722L176.111,52.16Z",
    transform: "translate(12.914 73.925)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10",
    d: "M129.9,69.941,146.5,45.218,129.9,20.5,113.293,45.218Z",
    transform: "translate(-106.622 45.892)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    d: "M134.751,76.883,151.357,52.16,134.751,27.438,118.145,52.16Z",
    transform: "translate(-87.029 73.925)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    d: "M126.837,59.656l15.926,23.71,19.231-28.632L181.23,83.365l15.931-23.71L161.994,7.319Z",
    transform: "translate(-51.927 -7.319)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    d: "M132.58,33.686l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-28.737 61.721)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-2",
    "data-name": "Path 14",
    d: "M145.034,44.682l-6.222-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-28.738 106.125)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-2",
    "data-name": "Path 15",
    d: "M130.519,41.689l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-37.062 94.038)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-2",
    "data-name": "Path 16",
    d: "M128.458,38.7l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-45.383 81.949)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    "data-name": "Path 17",
    d: "M126.4,35.7l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-53.708 69.862)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18-2",
    "data-name": "Path 18",
    d: "M136.79,32.709l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-62.03 57.776)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19-2",
    "data-name": "Path 19",
    d: "M122.274,29.715l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-70.353 45.686)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20-2",
    "data-name": "Path 20",
    d: "M132.668,26.722l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-78.676 33.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21-2",
    "data-name": "Path 21",
    d: "M130.607,23.729l-6.227-9.27-6.227,9.27L124.38,33Z",
    transform: "translate(-86.998 21.513)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22-2",
    "data-name": "Path 22",
    d: "M116.091,20.735l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-95.322 9.424)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24-2",
    "data-name": "Path 24",
    d: "M120.257,27.012l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-103.645 -2.664)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    d: "M134.641,41.689l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-20.416 94.038)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-2",
    "data-name": "Path 26",
    d: "M136.7,38.7l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-12.092 81.949)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    d: "M151.218,35.7l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-3.768 69.862)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    d: "M147.052,23.438l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(4.555 57.774)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M155.34,29.715l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(12.878 45.686)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M144.946,26.722l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(21.2 33.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M159.462,23.729l-6.227-9.27-6.227,9.27L153.235,33Z",
    transform: "translate(29.523 21.513)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M161.527,20.735l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(37.844 9.424)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M163.584,17.742l-6.222-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(46.169 -2.663)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M155.015,58.12h.005L139.074,34.38,123.128,58.12h0l15.946,23.74L155.02,58.12Z",
    transform: "translate(-66.906 101.957)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M129.9,97.319,146.5,72.6,129.9,47.874,113.293,72.6Z",
    transform: "translate(-106.622 156.449)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M134.751,90.377l16.606-24.722L134.751,40.932,118.145,65.655Z",
    transform: "translate(-87.029 128.417)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M170.066,58.12,154.12,34.38,138.174,58.12h0L154.12,81.86Z",
    transform: "translate(-6.148 101.959)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M164.353,47.874,147.747,72.6l16.606,24.722L180.959,72.6Z",
    transform: "translate(32.509 156.449)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M159.505,40.932,142.894,65.655l16.611,24.722,16.606-24.722Z",
    transform: "translate(12.914 128.417)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M181.225,55.771,162,84.4,142.758,55.771l-15.921,23.71L162,131.817l35.151-52.337Z",
    transform: "translate(-51.926 188.339)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M132.58,59.359l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-28.737 165.391)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M178.38,94.376l-19.7-29.332-19.7,29.332,19.7,29.332Z",
    transform: "translate(-2.91 225.784)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    d: "M138.8,57.633l6.227-9.27-6.227-9.27-6.222,9.27Z",
    transform: "translate(-28.736 120.988)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M147.1,51.356l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-20.418 133.073)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M136.7,54.349l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-12.092 145.162)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M144.986,48.072l-6.222,9.27,6.222,9.27,6.227-9.27Z",
    transform: "translate(-3.765 157.25)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M140.824,60.336l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(4.554 169.338)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M149.108,54.059l-6.222,9.27,6.222,9.27,6.227-9.27Z",
    transform: "translate(12.88 181.425)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M144.946,66.322l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(21.2 193.512)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M147.008,69.316l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(29.524 205.601)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M155.3,63.039l-6.227,9.27,6.227,9.27,6.227-9.27Z",
    transform: "translate(37.847 217.688)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M153.19,78.3l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(54.491 241.864)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    d: "M157.357,66.032,151.13,75.3l6.227,9.27,6.222-9.27Z",
    transform: "translate(46.172 229.775)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    d: "M130.519,51.356l6.227,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-37.062 133.073)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    d: "M128.458,54.349l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(-45.383 145.162)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M126.4,57.342l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-53.708 157.249)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M130.562,69.606l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-62.031 169.338)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M122.274,63.329,128.5,72.6l6.227-9.27-6.227-9.27Z",
    transform: "translate(-70.353 181.425)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M132.668,66.322l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-78.676 193.512)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M118.152,69.316l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-86.999 205.601)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62-2",
    "data-name": "Path 62",
    d: "M116.091,72.309l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-95.322 217.688)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63-2",
    "data-name": "Path 63",
    d: "M126.484,75.3l-6.227-9.27L114.03,75.3l6.227,9.27Z",
    transform: "translate(-103.646 229.775)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64-2",
    "data-name": "Path 64",
    d: "M164.353,84.043l-16.606,24.722,16.606,24.722,16.606-24.722Z",
    transform: "translate(32.509 302.508)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65-2",
    "data-name": "Path 65",
    d: "M159.505,90.985l-16.611,24.722,16.611,24.722,16.606-24.722Z",
    transform: "translate(12.914 330.539)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66-2",
    "data-name": "Path 66",
    d: "M129.9,133.484,146.5,108.766,129.9,84.044l-16.606,24.722Z",
    transform: "translate(-106.622 302.51)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67-2",
    "data-name": "Path 67",
    d: "M134.751,140.43l16.606-24.722L134.751,90.985l-16.606,24.722Z",
    transform: "translate(-87.029 330.541)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68-2",
    "data-name": "Path 68",
    d: "M126.837,123.207l15.926,23.71,19.231-28.637,19.236,28.637,15.931-23.71L161.994,70.865Z",
    transform: "translate(-51.927 249.293)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69-2",
    "data-name": "Path 69",
    d: "M145.034,97.234l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-28.738 318.337)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70-2",
    "data-name": "Path 70",
    d: "M140.534,123.713l19.7-29.332-19.7-29.337-19.7,29.337Z",
    transform: "translate(-76.166 225.781)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71-2",
    "data-name": "Path 71",
    d: "M138.808,98.959l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(-28.736 362.741)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72-2",
    "data-name": "Path 72",
    d: "M142.978,105.236l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-37.064 350.654)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-2",
    "data-name": "Path 73",
    d: "M140.912,102.242l-6.227-9.27-6.227,9.27,6.227,9.275Z",
    transform: "translate(-45.384 338.563)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74-2",
    "data-name": "Path 74",
    d: "M126.4,99.249l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-53.708 326.476)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75-2",
    "data-name": "Path 75",
    d: "M136.79,96.256l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-62.03 314.389)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76-2",
    "data-name": "Path 76",
    d: "M128.5,102.533l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-70.352 302.302)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77-2",
    "data-name": "Path 77",
    d: "M132.668,90.27,126.441,81l-6.227,9.27,6.227,9.27Z",
    transform: "translate(-78.676 290.215)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78-2",
    "data-name": "Path 78",
    d: "M130.607,87.281l-6.227-9.275-6.227,9.275,6.227,9.27Z",
    transform: "translate(-86.998 278.125)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79-2",
    "data-name": "Path 79",
    d: "M122.318,93.557l6.227-9.275-6.227-9.27-6.227,9.27Z",
    transform: "translate(-95.323 266.037)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80-2",
    "data-name": "Path 80",
    d: "M124.423,78.3l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-111.969 241.864)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81-2",
    "data-name": "Path 81",
    d: "M120.257,90.559l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-103.645 253.95)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82-2",
    "data-name": "Path 82",
    d: "M147.1,105.236l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-20.418 350.654)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83-2",
    "data-name": "Path 83",
    d: "M149.156,102.242l-6.222-9.27-6.232,9.27,6.232,9.275Z",
    transform: "translate(-12.093 338.563)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84-2",
    "data-name": "Path 84",
    d: "M151.218,99.249l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-3.768 326.476)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85-2",
    "data-name": "Path 85",
    d: "M147.052,86.986l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(4.555 314.39)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86-2",
    "data-name": "Path 86",
    d: "M155.34,93.263l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(12.878 302.302)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87-2",
    "data-name": "Path 87",
    d: "M144.946,90.27l6.227,9.27,6.232-9.27L151.173,81Z",
    transform: "translate(21.2 290.215)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88-2",
    "data-name": "Path 88",
    d: "M159.462,87.281l-6.227-9.275-6.227,9.275,6.227,9.27Z",
    transform: "translate(29.523 278.125)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89-2",
    "data-name": "Path 89",
    d: "M161.527,84.282l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(37.844 266.037)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90-2",
    "data-name": "Path 90",
    d: "M151.13,81.289l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(46.17 253.951)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91-2",
    "data-name": "Path 91",
    d: "M155.02,121.667h0l-15.946-23.74-15.946,23.74,15.946,23.74Z",
    transform: "translate(-66.906 358.573)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M129.9,160.862,146.5,136.144,129.9,111.422l-16.606,24.722Z",
    transform: "translate(-106.622 413.067)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M134.751,153.924,151.357,129.2l-16.606-24.722L118.145,129.2Z",
    transform: "translate(-87.029 385.032)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2",
    "data-name": "Path 94",
    d: "M170.066,121.667h0L154.12,97.927l-15.946,23.74h0l15.946,23.74Z",
    transform: "translate(-6.148 358.573)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-2",
    "data-name": "Path 95",
    d: "M164.353,111.421l-16.606,24.722,16.606,24.717,16.606-24.717Z",
    transform: "translate(32.509 413.065)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96-2",
    "data-name": "Path 96",
    d: "M159.505,104.479,142.894,129.2l16.611,24.722L176.111,129.2Z",
    transform: "translate(12.914 385.03)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97-2",
    "data-name": "Path 97",
    d: "M197.155,143.028l-15.926-23.71L162,147.955l-19.236-28.637-15.926,23.71L162,195.369Z",
    transform: "translate(-51.929 444.953)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    d: "M145.034,122.905l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-28.738 422.005)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-2",
    "data-name": "Path 99",
    d: "M132.58,111.914l6.222,9.27,6.232-9.27-6.232-9.275Z",
    transform: "translate(-28.737 377.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100-2",
    "data-name": "Path 100",
    d: "M147.1,114.907l-6.227-9.275-6.232,9.275,6.232,9.27Z",
    transform: "translate(-20.418 389.687)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101-2",
    "data-name": "Path 101",
    d: "M149.156,117.9l-6.222-9.27L136.7,117.9l6.232,9.27Z",
    transform: "translate(-12.093 401.778)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102-2",
    "data-name": "Path 102",
    d: "M151.218,120.89l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-3.768 413.865)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103-2",
    "data-name": "Path 103",
    d: "M140.824,123.883l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(4.554 425.952)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-2",
    "data-name": "Path 104",
    d: "M155.34,126.876l-6.227-9.27-6.227,9.27,6.227,9.275Z",
    transform: "translate(12.878 438.039)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-2",
    "data-name": "Path 105",
    d: "M144.946,129.874l6.227,9.27,6.232-9.27-6.232-9.275Z",
    transform: "translate(21.2 450.126)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106-2",
    "data-name": "Path 106",
    d: "M147.008,132.863l6.222,9.27,6.232-9.27-6.232-9.27Z",
    transform: "translate(29.524 462.217)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-2",
    "data-name": "Path 107",
    d: "M161.527,135.857l-6.227-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(37.844 474.303)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108-2",
    "data-name": "Path 108",
    d: "M153.19,141.843l6.227,9.275,6.232-9.275-6.232-9.27Z",
    transform: "translate(54.491 498.478)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M157.357,129.58l-6.227,9.27,6.227,9.27,6.222-9.27Z",
    transform: "translate(46.172 486.391)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-2",
    "data-name": "Path 110",
    d: "M142.978,114.907l-6.227-9.275-6.232,9.275,6.232,9.27Z",
    transform: "translate(-37.064 389.687)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111-2",
    "data-name": "Path 111",
    d: "M140.912,117.9l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-45.384 401.778)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112",
    d: "M138.851,120.89l-6.222-9.27-6.232,9.27,6.232,9.27Z",
    transform: "translate(-53.709 413.865)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113-2",
    "data-name": "Path 113",
    d: "M136.79,123.883l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-62.03 425.952)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114-2",
    "data-name": "Path 114",
    d: "M122.274,126.876l6.227,9.275,6.227-9.275-6.227-9.27Z",
    transform: "translate(-70.353 438.039)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115-2",
    "data-name": "Path 115",
    d: "M132.668,129.874l-6.227-9.275-6.227,9.275,6.227,9.27Z",
    transform: "translate(-78.676 450.126)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116-2",
    "data-name": "Path 116",
    d: "M130.607,132.863l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-86.998 462.217)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117-2",
    "data-name": "Path 117",
    d: "M116.091,135.857l6.227,9.27,6.227-9.27-6.227-9.27Z",
    transform: "translate(-95.322 474.303)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118-2",
    "data-name": "Path 118",
    d: "M118.2,132.573l-6.227,9.27,6.227,9.275,6.227-9.275Z",
    transform: "translate(-111.968 498.478)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119-2",
    "data-name": "Path 119",
    d: "M126.484,138.85l-6.227-9.27-6.227,9.27,6.227,9.27Z",
    transform: "translate(-103.646 486.391)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M128.9,171.3h49.54l-24.773-36.885Z",
    transform: "translate(-43.599 505.901)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121-2",
    "data-name": "Path 121",
    d: "M178.38,157.919h0l-19.7-29.327-19.7,29.327,19.7,29.332Z",
    transform: "translate(-2.91 482.402)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122-2",
    "data-name": "Path 122",
    d: "M160.239,157.919l-19.7-29.327-19.7,29.327,19.7,29.332Z",
    transform: "translate(-76.165 482.402)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M116.091,147.83l4.509,6.711h3.441l4.5-6.711-6.222-9.27Z",
    transform: "translate(-95.323 522.655)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M120.257,154.107l6.227-9.27-6.227-9.27-6.227,9.27Z",
    transform: "translate(-103.645 510.567)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M149.069,147.83l4.509,6.711h3.436l4.509-6.711-6.227-9.27Z",
    transform: "translate(37.847 522.655)",
    fill: "#0062af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M163.584,144.841l-6.222-9.275-6.232,9.275,6.232,9.27Z",
    transform: "translate(46.169 510.564)",
    fill: "#0062af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.58b90272e61da501ee41fb0b05a3966e.svg";
export { ForwardRef as ReactComponent };